<template>
  <div class="dashboard">
    <PageSection class="do-not-print" title="Filters">
      <LocationFilter @update:filter="filterUpdated"></LocationFilter>
    </PageSection>
    <PageSection title="Dashboard">
      <div class="panels">
        <div class="panel full">
          <ActiveOutbreaks :filters="{facIds, unitIds}"/>
        </div>
        <div class="panel full">
          <FrequencyChart :filters="{facIds, unitIds}"/>
        </div>
        <div class="panel" v-if="$configStore.hhModuleEnabled()">
          <HandHygieneCompliance :filters="{facIds, unitIds}" />
        </div>
        <div class="panel" v-if="$configStore.ppeModuleEnabled()">
          <PPECompliance :filters="{facIds, unitIds}" />
        </div>
        <div class="panel">
          <CasesCreated :filters="{facIds, unitIds}" />
        </div>
        <div class="panel">
          <CasesUpdated :filters="{facIds, unitIds}"/>
        </div>
      </div>
    </PageSection>
  </div>
</template>

<script>
import LocationFilter from "../LocationFilter/LocationFilter.vue";
import PageSection from "../Shared/PageSection.vue";
import CasesCreated from "./CasesCreated.vue";
import CasesUpdated from "./CasesUpdated.vue";
import FrequencyChart from "./FrequencyChart.vue";
import ActiveOutbreaks from "./ActiveOutbreaks.vue";
import HandHygieneCompliance from './HandHygieneCompliance.vue'
import PPECompliance from './PPECompliance.vue'

export default {
  name: "Dashboard",
  components: {
    PageSection,
    LocationFilter,
    CasesCreated,
    CasesUpdated,
    FrequencyChart,
    ActiveOutbreaks,
    PPECompliance,
    HandHygieneCompliance
  },
  data() {
    return {
      facIds: [],
      unitIds: [],
    };
  },
  methods: {
    filterUpdated({ sites, units }) {
      this.facIds = Array.from(sites);
      this.unitIds = Array.from(units);
    }
  }
};
</script>

<style scoped>
.panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  align-items: start;
}
.full {
  grid-column: 1/-1;
}
</style>
